export const newException = {
  order_number: '',
  expires_at: null,
  notes: '',
  enabled_for_refunds: false,
  enabled_for_exchanges: false,
  disable_return_fees: false,
  disable_exchange_fees: false,
  only_store_credit: false,
  only_gift_card: false,
  send_notification_on_creation: false,
  refund_shipping_amount: false,
  policy_rule_id: null,
}

export const exceptionEffectFields = [
  'disable_return_fees',
  'disable_exchange_fees',
  'only_store_credit',
  'only_gift_card',
  'refund_shipping_amount',
  'enabled_for_refunds',
  'enabled_for_exchanges',
  'policy_rule_id',
]
